import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Button, Upload, message } from 'antd';
import uploaderApi from 'utils/api/Uploader/UploaderApi';
import './UploaderComponent.less';

const UploaderComponent = (props) => {
  const {
    customClassName, images, label, limit, listType, tags, token, type,
  } = props;

  /**
   * fileList is the antd file list.
   * DisabledUpload is flag to disable the ant upload when is processing the file.
   */
  const [fileList, setFileList] = useState([]);
  const [disabledUpload, setDisabledUpload] = useState(false);

  useEffect(() => {
    if (images.length > 0) {
      if (images.length > limit) setFileList(images[0]);
      else setFileList(images);
    }
  }, [images]);

  /**
   * method to handle the image when is post it!.
   * @param response
   * @param file
   */
  const handleImage = (response, file) => {
    props.handleImage(response, file.uid);
    message.success('archivo subido');
    setDisabledUpload(false);
  };

  /**
   * Method to handle the flatlist, to limit the uploads and delete the image.
   * @param info
   */
  const handleOnChange = (info) => {
    if (info.file.size <= 800000 || info.file.status === 'removed') {
      if (info.fileList.length > limit) {
        props.handleOnRemove(fileList[0]);
      }
      const fList = info.fileList.slice(-limit);
      setFileList(fList);
    }
  };

  /**
   * Method to manage the remove function.
   * @param file
   */
  const handleOnRemove = (file) => {
    props.handleOnRemove(file);
  };

  /**
   * Method to send the pure file to the custom Request.
   * @param file
   * @returns {Promise<unknown>}
   */
  const transFormFile = (file) =>
    // eslint-disable-next-line implicit-arrow-linebreak
    new Promise((resolve) => {
      resolve(file);
    });

  /**
   * Method to disabled the antd uploader.
   */
  const onProgress = () => {
    setDisabledUpload(true);
  };

  /**
   * Custom request to save the image in formData.
   * @param data
   */
  const customRequest = (data) => {
    const { file } = data;
    const formData = new FormData();
    formData.append('file', file);
    formData.append('tags', tags);
    formData.append('type', type);

    /**
     * call to the media service to upload the image
     */
    uploaderApi
      .postImage(formData, token, onProgress)
      .then(({ data: response }) => {
        handleImage(response, file);
      })
      .catch((error) => message.error(error.toString()));
  };

  /**
   * Method to handle the file size limit.
   * @param file
   * @returns {boolean}
   */
  const handleBeforeUpload = (file) => {
    try {
      if (file.size > 800000) {
        message.error('La imagen no puede pesar más de 800kb');
        return false;
      }
      return true;
    } catch (error) {
      return error;
    }
  };

  return (
    <div className="uploader-component-container">
      <div className="uploader-component-label">
        <h3>{label}</h3>
      </div>
      <Upload
        accept="image/png,image/jpg,image/jpeg"
        beforeUpload={handleBeforeUpload}
        className={`${customClassName} uploader-component-list-inline`}
        customRequest={customRequest}
        disabled={disabledUpload}
        fileList={fileList}
        listType={listType}
        onChange={handleOnChange}
        onRemove={handleOnRemove}
        transformFile={transFormFile}
      >
        <Button icon="upload">Subir imagen</Button>
      </Upload>
    </div>
  );
};

UploaderComponent.defaultProps = {
  customClassName: '',
  handleImage: '',
  images: [],
  label: '',
  limit: 0,
  tags: [],
};

UploaderComponent.propTypes = {
  customClassName: PropTypes.string,
  handleImage: PropTypes.func,
  handleOnRemove: PropTypes.func.isRequired,
  label: PropTypes.string,
  limit: PropTypes.number,
  listType: PropTypes.string.isRequired,
  token: PropTypes.string.isRequired,
  type: PropTypes.number.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  tags: PropTypes.array,
  // eslint-disable-next-line react/forbid-prop-types
  images: PropTypes.array,
};

export default UploaderComponent;
